import { KJUR, hextob64, RSAKey, pemtohex } from 'jsrsasign'

const CIPHER_ALGORITHM = 'RSA'

const cipherWithPublicKey = (text, publicKey) => {
    try {
        const rsaKey = new RSAKey()
        const hCert = pemtohex(atob(publicKey));
        rsaKey.readPKCS8PubKeyHex(hCert)

        return hextob64(KJUR.crypto.Cipher.encrypt(text, rsaKey, CIPHER_ALGORITHM))
    } catch(error){
        console.error(`Eurobits Cipher Error: ${error}`) // eslint-disable-line no-console
    }
}

export { cipherWithPublicKey }